import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HomeLocation.scss';
import Images from '../../Assets/Images/Images';

const HomeLocation = () => {
  return (
    <div className='home-location'>
      <Container>
        <Row>
          <Col>
            <h2 className='home-location__title'>Lokasi Strategis Dekat dekat dengan kampus dan perkantoran</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={{ span: 4, offset: 4 }}>
            <p className='home-location__text'>Terletak di kawasan strategis, Hanya berjarak 180M atau 2 menit ke FKG
              Moestopo, 900m atau 10 Menit ke STP Trisakti, dan 500m atau 5 menit ke gerbang tol veteran. Mudah
              dijangkau transportasi publik seperti TransJakarta dan angkutan umum. Membuat house of arie berada di
              lokasi yang ideal untuk ditempati.</p>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <img className='home-location__image' alt='' src={Images.homeLocOne} />
          </Col>
          <Col md={6}>
            <img className='home-location__image' alt='' src={Images.homeLocTwo} />
          </Col>
        </Row>
        <div className='home-location__bottom'>
          <Row>
            <Col lg={4}>
              <div className='home-location__sub-wrapper'>
                <h3 className='home-location__sub-title'>Kost Putri yang mengutamakan Kenyamanan bagi penghuni, Tempat
                  melarikan diri dari hiruk pikuk kota Jakarta.</h3>
              </div>
            </Col>
            <Col lg={{ span: 6, offset: 2 }}>
              <img className='home-location__image' alt='' src={Images.menu} />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default HomeLocation;
